import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { menuItems } from "./roles";
import { resolvePermissionByPath } from "./resolvePermissionByPath";

const ProtectedRoute = () => {
  const { isAuthenticated, userValidated, userPermissions, loading } = useAuth();
  const location = useLocation();

  // Wait for session restoration
  if (loading) {
    return <div className="text-center p-10 text-gray-500">Loading...</div>;
  }

  // Redirect only if truly unauthenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but user not validated yet, show loader
  if (!userValidated) {
    return <div className="text-center p-10 text-gray-500">Loading...</div>;
  }

  // Resolve required permission dynamically
  const requiredPermission = resolvePermissionByPath(menuItems, location.pathname);

  // Routes not tied to menu → allow
  if (!requiredPermission) return <Outlet />;

  // Unauthorized if permission missing
  if (!userPermissions?.includes(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
